"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = Badge;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
const tooltip_1 = require("./tooltip");
const VARIANTS = {
    default: 'border-transparent bg-primary text-primary-foreground',
    secondary: 'border-transparent bg-secondary text-secondary-foreground',
    destructive: 'border-transparent bg-destructive text-destructive-foreground',
    /* The only variant that keeps its border — it has no fill to be identified by. */
    outline: 'text-foreground',
};
/**
 * ⚠️ **`tabular-nums` is in the base class, and it is load-bearing.** A badge is very often a
 * count, and a count that changes width as it counts makes a row jitter. The mockup puts it
 * here rather than at each call site for exactly that reason.
 *
 * ⚠️ **Spreads its remaining props onto the DOM node**, which matters more than it looks: any
 * of these may be handed to a Radix `asChild` slot later — a tooltip trigger around a badge is
 * the obvious case — and `asChild` passes handlers, `aria-*` and the ref through props. A
 * component accepting only its declared props drops every one of them, renders perfectly, and
 * does nothing.
 */
/* ⚠️ `title` is the kit's tooltip, never the browser's — `Button` carries the argument. */
function Badge({ variant = 'default', className, children, title, ...rest }) {
    const tip = (0, tooltip_1.useTooltip)(title);
    return ((0, jsx_runtime_1.jsxs)("span", { className: (0, cn_1.cn)('inline-flex w-fit items-center justify-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-px text-[11px] font-medium tabular-nums', VARIANTS[variant], className), ...rest, ...tip.triggerProps(rest), children: [children, tip.bubble] }));
}
//# sourceMappingURL=badge.js.map